import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { MzBaseModal } from "ng2-materialize";
import { environment } from "../../../environments/environment";
import { Subject } from "rxjs";
@Component({
  selector: "app-send-questionnaire",
  templateUrl: "./send-questionnaire.component.html",
  styleUrls: ["./send-questionnaire.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendQuestionnaireComponent extends MzBaseModal implements OnInit {
  constructor() {
    super();
  }

  private resultSubject: Subject<boolean>;
  readonly env: any = environment;
  @Input() message: string;
  @Input() cancelButtonText: string = "Abbrechen";
  @Input() confirmButtonText: string = "Senden";

  ngOnInit() {
    /*
    var subscription = this.modalComponent.onClose.subscribe(x => {
      if (!this.resultSubject.closed) {
        this.resultSubject.next(false);
        this.resultSubject.complete();
      }
      })
  */
  }

  async getResultAsync() {
    this.modalComponent.open();
    this.resultSubject = new Subject<boolean>();
    return this.resultSubject.first().toPromise();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/send-questionnaire/send-questionnaire.component.ts